/** Accidental UV checker maps left in FBX exports — load a 1×1 transparent PNG instead. */
export const TRANSPARENT_PNG_DATA_URL =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='

export function isAlignCheckerTextureUrl(url: string): boolean {
  const filename = url.split(/[/\\]/).pop() || url
  return /^UV_\d+cm_AlignChecker\.png$/i.test(filename)
}

export function resolveAlignCheckerTextureUrl(url: string): string {
  return isAlignCheckerTextureUrl(url) ? TRANSPARENT_PNG_DATA_URL : url
}
